








  import { Component, Vue } from 'vue-property-decorator';
  
@Component({
  name:"ListPages",
  components:{}
})
export default class ListPages extends Vue {
  private arianeItems = [
    { text: 'Administration', disabled: false, to: {name:'Admin'}, exact:true},
    { text: 'Dashboard', disabled: false, to: {name:'Dashboard'}, exact:true},
    { text: 'Pages',       disabled: true,  to: {name: 'ListPages'}}
  ]  
}
